export { StripBannerRenderer } from './StripBannerRenderer'
export type { StripBannerRendererProps } from './StripBannerRenderer'
